<template>
  <FullscreenFrontageDialog ref="frontageDialog">
    <template slot-scope="dialogProps">
      <ClientPackageHistoryDialog :is-open="true"
                                  v-bind="dialogProps"
                                  @close="handleClose"/>
    </template>
  </FullscreenFrontageDialog>
</template>

<script>
import {FullscreenFrontageDialog} from "@/modules/common/components";
import ClientPackageHistoryDialog from "@/modules/clientPackageHistory/components/ClientPackageHistoryDialog.vue";

export default {
  components: {ClientPackageHistoryDialog, FullscreenFrontageDialog},
  methods: {
    handleClose(data) {
      this.$refs.frontageDialog.handleClose(data);
    }
  }
}
</script>
